var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtHomelender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A4C5F2",
    d: "M26 2L35.282 11.106 35.282 26.355 31 28 21.57 26.112 16 25.106 16 12z",
    transform: "translate(2 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M28.14 16c.513 0 .936.386.993.884l.007.116v10c0 .552-.448 0-1 0-.513 0-.936.614-.993.117L27.14 27c-2.257-.043-3.552-.045-3.883-.007L23.14 27c-.513 0-.936-.386-.993-.883L22.14 26v-9c0-.513.386-.935.883-.993L23.14 16h5z",
    transform: "translate(2 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M44.389 22.404c.212.286.256.662.116.99-.84 1.966-4.133 7.105-5.173 8.272l-.322.355c-2.364 2.57-6.932 6.778-8.33 6.972l-.094.007h-14c-.481 0-.702.102-.96.358l-.333.35c-.39.39-1.024.39-1.414 0-.36-.361-.389-.928-.084-1.32l.376-.403.045-.046c.567-.563 1.22-.887 2.135-.933l.235-.006h14c.413 0 5.671-4.892 7.253-6.665.786-.882 3.315-4.786 4.44-6.93l.084-.164-.066-.037c-.546-.291-1.387-.434-2.279-.272l-.206.042c-1.305.303-2.165 1.202-3.337 3.483-.074.144-.181.268-.313.36l-.103.064-3.522 1.894-.026.012c.403 1.901-.827 4.095-3.69 4.209l-.235.004h-8c-.553 0-1-.448-1-1 0-.513.386-.935.883-.993l.117-.007h8c2.606 0 2.665-2.865.177-2.995L28.586 28h-5.283c-.443 0-.83-.17-1.298-.477-.112-.074-.227-.156-.36-.253l-.622-.473c-.387-.293-.652-.475-.898-.608-.201-.109-.362-.167-.476-.184L19.586 26h-5c-.878 0-2.28.765-3.293 1.707l-4 4c-.39.39-1.024.39-1.414 0-.39-.39-.39-1.023 0-1.414l4.025-4.025c1.302-1.211 2.998-2.163 4.443-2.26l.239-.008h5c.497 0 .982.155 1.491.43.306.166.596.359.963.63l1.254.932.009.008h5.283c1.301 0 2.285.417 2.951 1.047l.053-.034 3.251-1.748.012-.022c1.299-2.45 2.48-3.673 4.286-4.162l.22-.055c2.044-.475 4.108.137 5.03 1.378z",
    transform: "translate(2 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5593E7",
    d: "M12.293 45.293l3.586-3.586c.39-.39.39-1.023 0-1.414L5.293 29.707c-.391-.39-1.023-.39-1.414 0L.293 33.293c-.391.391-.391 1.023 0 1.414l10.586 10.586c.39.391 1.023.391 1.414 0M26.199.21l.094.083 14 14c.39.39.39 1.024 0 1.414-.36.36-.928.389-1.32.083l-.094-.083L25.585 2.414l-6.283 6.284-.019.019-6.99 6.99c-.36.36-.928.389-1.32.083l-.094-.083c-.36-.36-.389-.927-.084-1.32l.084-.094 6.707-6.709V3c0-.552.447-1 1-1 .513 0 .935.386.993.884l.007.116v2.584l5.293-5.29c.36-.361.927-.39 1.32-.084z",
    transform: "translate(2 1)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M4.064 33.126c.36-.36.928-.388 1.32-.083l.094.083 1 1c.39.39.39 1.024 0 1.414-.36.36-.927.389-1.32.083l-.094-.083-1-1c-.39-.39-.39-1.023 0-1.414z",
    transform: "translate(2 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtHomelender);
export default __webpack_public_path__ + "static/media/art-homelender.277f9e93dbdc048bf101d2dee767d23c.svg";
export { ForwardRef as ReactComponent };